import React from 'react';
import { AuthConsumer } from './authProvider';
export const AuthSignInPage = () => (
    <AuthConsumer>
        {({ signinRedirect }) => {
            signinRedirect();
            return <se-loading loading="true"></se-loading>;
        }}
    </AuthConsumer>
);